export const SET_HRES62E_INDEX_DISP = 'SET_HRES62E_INDEX_DISP'
export const GET_HRES62E_INDEX_DISP = 'GET_HRES62E_INDEX_DISP'
export const SET_HRES62E_DETAIL_DISP = 'SET_HRES62E_DETAIL_DISP'
export const GET_HRES62E_DETAIL_DISP = 'GET_HRES62E_DETAIL_DISP'
export const GET_HRES62E_MAX_ROWSPAN = 'GET_HRES62E_MAX_ROWSPAN'
export const SET_HRES62E_COLUMNS = 'SET_HRES62E_COLUMNS'
export const GET_HRES62E_COLUMNS = 'GET_HRES62E_COLUMNS'
export const SET_HRES62E_LABELS = 'SET_HRES62E_LABELS'
export const GET_HRES62E_LABELS = 'GET_HRES62E_LABELS'
export const RECEIVED_HRES62E_COLUMNS_LABELS = 'RECEIVED_HRES62E_COLUMNS_LABELS'
export const SET_HRES62E_INDEX = 'SET_HRES62E_INDEX'
export const GET_HRES62E_INDEX = 'GET_HRES62E_INDEX'
export const SET_HRES62E_INDEX_SELECTED = 'SET_HRES62E_INDEX_SELECTED'
export const GET_HRES62E_INDEX_SELECTED = 'GET_HRES62E_INDEX_SELECTED'
export const RECEIVED_HRES62E_INDEX = 'RECEIVED_HRES62E_INDEX'
export const RECEIVED_HRES62E_CREATE = 'RECEIVED_HRES62E_CREATE'
export const SET_HRES62E_DETAIL = 'SET_HRES62E_DETAIL'
export const GET_HRES62E_DETAIL = 'GET_HRES62E_DETAIL'
export const RECEIVED_HRES62E_DETAIL = 'RECEIVED_HRES62E_DETAIL'
export const SET_HRES62E_DROPDOWNS = 'SET_HRES62E_DROPDOWNS'
export const GET_HRES62E_DROPDOWNS = 'GET_HRES62E_DROPDOWNS'
export const RECEIVED_HRES62E_DROPDOWNS = 'RECEIVED_HRES62E_DROPDOWNS'
export const TOGGLE_HRES62E_PAGE = 'TOGGLE_HRES62E_PAGE'
export const POST_HRES62E_SAVE = 'POST_HRES62E_SAVE'
export const POST_HRES62E_CANCEL = 'POST_HRES62E_CANCEL'
export const GET_HRES62E_ENTITLE_FLAG_LEAVE = 'GET_HRES62E_ENTITLE_FLAG_LEAVE'
export const SET_HRES62E_ENTITLE_FLAG_LEAVE = 'SET_HRES62E_ENTITLE_FLAG_LEAVE'
export const RECEIVED_HRES62E_ENTITLE_FLAG_LEAVE = 'RECEIVED_HRES62E_ENTITLE_FLAG_LEAVE'
export const GET_HRES62E_WORKTIME = 'GET_HRES62E_WORKTIME'
export const SET_HRES62E_WORKTIME = 'SET_HRES62E_WORKTIME'
export const RECEIVED_HRES62E_WORKTIME = 'RECEIVED_HRES62E_WORKTIME'
export const GET_HRES62E_POPUP = 'GET_HRES62E_POPUP'
export const SET_HRES62E_POPUP = 'SET_HRES62E_POPUP'
export const RECEIVED_HRES62E_POPUP = 'RECEIVED_HRES62E_POPUP'
export const SET_HRES62E_CODLEAVE = 'SET_HRES62E_CODLEAVE'
export const RECEIVED_HRES62E_CODLEAVE = 'RECEIVED_HRES62E_CODLEAVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres62e/mutation-types.js